import styles from "../../../businessSetting/deliveryRanges/dealer/DealerDeliveryRanges.module.scss";
import { Grid } from "@material-ui/core";
import React from "react";
import Item from "../../../../shared/item/Item";
import { Link } from "react-router-dom";

export const StatusOverviewRow = (props) => {
  const formatData = (data) => {
    switch (data && data.status) {
      case true:
        return (
          <span data-testid="upToDate">
            {props.t("PricingWrapper.upToDate")} ({data.year.toFixed(2)})
          </span>
        );
      case false:
        return data.priceChange ? (
          <span className={styles.redText} data-testid="pricingUpdate">
            {props.t("PricingWrapper.pricingUpdate")} ({data.year.toFixed(2)})
          </span>
        ) : (
          <span className={styles.redText} data-testid="pendingReview">
            {props.t("PricingWrapper.pendingReview")} ({data.year.toFixed(2)})
          </span>
        );
      default:
        return <span> </span>;
    }
  };

  return (
    <Grid
      container
      className={`${styles.rowBorder} pagePaddingLeft pagePaddingRight`}
    >
      {Object.values(props.vehicle).map((vehicleData, index) => (
        <Grid
          item
          xs={3}
          className={
            index > 0 ? `${styles.rowItem} ${styles.right}` : styles.rowItem
          }
          key={index}
        >
          <Link
            className={styles.link}
            to={{
              pathname: "pricing/vehicles",
              query:
                index > 0 && vehicleData
                  ? { model: props.vehicle.model, modelYear: vehicleData.year }
                  : { model: props.vehicle.model },
            }}
          >
            <Item value={index > 0 ? formatData(vehicleData) : vehicleData} />
          </Link>
        </Grid>
      ))}
    </Grid>
  );
};
